/**
 * Wann ein Video ein neues Bild hat -- damit die Leinwand es nur dann
 * hochlädt (7.69f).
 *
 * Die Grafikkarte holte sich das Bild bei jedem Durchlauf, sechzigmal je
 * Sekunde, aus einem Video, das fünfundzwanzig Bilder liefert. Mehr als die
 * Hälfte der Uploads war dasselbe Bild noch einmal. `requestVideoFrameCallback`
 * sagt, wann wirklich ein neues da ist; der Zähler am Element ist die
 * `version`, an der der Maler ein unverändertes Bild erkennt.
 *
 * Wo es die Funktion nicht gibt, bleibt der Zähler leer -- dann lädt der
 * Maler wie bisher bei jedem Durchlauf.
 */
type MitBildtakt = HTMLVideoElement & {
  requestVideoFrameCallback?: (cb: () => void) => number;
  cancelVideoFrameCallback?: (id: number) => void;
};

/** Wie viele Bildtakte insgesamt kamen -- für den Bericht (7.69h). */
export const takte = { n: 0, seit: typeof performance !== 'undefined' ? performance.now() : 0 };

export function bildtakt(video: HTMLVideoElement): () => void {
  const v = video as MitBildtakt;
  if (!v.requestVideoFrameCallback) return () => undefined;
  let id = 0;
  const weiter = (): void => {
    v.dataset.bild = String((Number(v.dataset.bild) || 0) + 1);
    takte.n += 1;
    id = v.requestVideoFrameCallback!(weiter);
  };
  id = v.requestVideoFrameCallback(weiter);
  return () => v.cancelVideoFrameCallback?.(id);
}

/**
 * Der Stand des Bildes, das gerade im Element steht.
 *
 * Aus dem Bildtakt *und* der Medienzeit: Der Takt allein reichte nicht --
 * bleibt der Rückruf aus (auf iOS womöglich für ein Video, das ganz verdeckt
 * ist), stünde die Leinwand still, obwohl das Video läuft. Die Medienzeit
 * rückt in jedem Fall weiter. Ohne Takt-Unterstützung zählt nur sie; dann
 * lädt der Maler bei jeder neuen Hundertstelsekunde.
 */
export function bildNummer(video: HTMLVideoElement): number {
  const takt = Number(video.dataset.bild) || 0;
  return takt * 1_000_000 + Math.round(video.currentTime * 100);
}
